import { createSlice } from "@reduxjs/toolkit";
import { getVibemartThemeTopCategory } from "./ThunkAction";
import { VibemartThemeState } from "./Tpyes";

const initialState: VibemartThemeState = {
  isLoading: false,
  topCategories: [],
  errorMessage: null,
};

const vibemartThemeSlice = createSlice({
  name: "vibemartTheme",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 🔹 GET ONLY
    builder.addCase(getVibemartThemeTopCategory.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = null;
    });

    builder.addCase(getVibemartThemeTopCategory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.topCategories = action.payload?.data?.data || [];
    });

    builder.addCase(getVibemartThemeTopCategory.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload?.message || "Something went wrong";
    });
  },
});

export default vibemartThemeSlice.reducer;
